import type { Theme } from "../lib/theme.js";

const OPTIONS: Array<{ value: Theme; label: string }> = [
  { value: "light", label: "Day" },
  { value: "dark", label: "Refuge" },
  { value: "system", label: "Auto" },
];

export function ThemeToggle({
  theme,
  onChange,
}: {
  theme: Theme;
  onChange: (t: Theme) => void;
}) {
  return (
    <div role="group" aria-label="Theme" className="inline-flex rounded-[var(--radius-control)] border border-granite-300 dark:border-granite-600 overflow-hidden">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          aria-pressed={theme === opt.value}
          className={`min-h-[44px] px-3 text-[14px] font-text transition-colors ${
            theme === opt.value
              ? "bg-granite-800 text-granite-50 dark:bg-granite-100 dark:text-granite-900"
              : "bg-transparent text-granite-600 hover:bg-granite-100 dark:hover:bg-granite-800"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
